import ENGLISH from '../languages/english/english';
import FRENCH from '../languages/french/french';
import GERMAN from '../languages/german/german';
import ITALIAN from '../languages/italian/italian';
import NORWEGIAN from '../languages/norwegian/norwegian';
import FINNISH from '../languages/finnish/finnish';
import SWEDISH from './swedish/swedish';

const LANGUAGES = [
  { code: 'en', name: 'English', data: ENGLISH },
  { code: 'fr', name: 'French', data: FRENCH },
  { code: 'de', name: 'German', data: GERMAN },
  { code: 'it', name: 'Italian', data: ITALIAN },
  { code: 'no', name: 'Norwegian', data: NORWEGIAN },
  { code: 'fi', name: 'Finnish', data: FINNISH },
  { code: 'se', name: 'Swedish', data: SWEDISH },
];

export function getLanguages() {
  return LANGUAGES;
}

export function getLanguage(code) {
  const languages = getLanguages();
  let language = languages.find((lang) => lang.code === code);
  if (!language) {
    language = languages[0];
  }
  return language.data;
}
